import Image from "next/image";
import Link from "next/link";
import { routes } from "@/lib/links";

const legalLinks = [
  { href: routes.shop, label: "Shop" },
  { href: routes.free, label: "Free sample" },
  { href: routes.terms, label: "Terms of Service" },
  { href: routes.privacy, label: "Privacy Policy" },
  { href: routes.refund, label: "Refund Policy" },
  { href: routes.licence, label: "Licence" },
];

export function ComingSoonFooter() {
  return (
    <footer className="mx-auto flex max-w-[1200px] flex-wrap items-center justify-between gap-x-8 gap-y-5 px-5 pt-10 pb-10 text-sm sm:px-8 sm:pt-12">
      <Link href={routes.home} aria-label="Carnies" className="inline-flex items-center">
        <Image
          src="/brand/carnies.svg"
          alt="carnies."
          width={320}
          height={88}
          className="h-10 w-auto sm:h-12"
        />
      </Link>

      <nav aria-label="Footer">
        <ul className="flex flex-wrap gap-x-5 gap-y-1 font-semibold sm:gap-x-6">
          {legalLinks.map((l) => (
            <li key={l.href}>
              <Link href={l.href} className="inline-block py-1.5 transition-colors hover:text-brand">
                {l.label}
              </Link>
            </li>
          ))}
        </ul>
      </nav>

      <p className="text-ink">
        © {new Date().getFullYear()} carnies. All rights reserved.
      </p>
    </footer>
  );
}
